<template>
    <b-card class="m-0">
      <div v-if="!show.overlay">
        <table-render  id="table-tickets-manifest" :schema="schema" :actions="actions" :rows="rows" :fixed="true">
          <template #id="scope">
            <b-button class="search-advanced font-info-color" variant="link" v-b-tooltip.hover title="Ir al detalle" @click="openSummaryDetails(scope.rowdata.id)">{{ scope.rowdata.id }}</b-button>
          </template>
          <template #courierSlot="scope">
            <div>
              <img :src="`https://storage.googleapis.com/enviame-misc/carriers/logos/color/${scope.rowdata.carrier_code.toLowerCase()}.png`" :alt="scope.rowdata.carrier_code" height="61">
            </div>
          </template>
          <template #marketplaceSlot="scope">
            <div>
              <img
                v-if="scope.rowdata.marketplace_logo"
                :src="scope.rowdata.marketplace_logo"
                :alt="scope.rowdata.marketplace_logo"
                height="61"
                v-b-tooltip.hover :title="scope.rowdata.tooltip">
              <img
                v-else
                src="https://storage.googleapis.com/marketcenter-labels/Logo-noaplica.png"
                alt="Default logo"
                height="61">
            </div>
          </template>
          <template #actionsSlot="scope">
            <div class="table-manifest--buttons">
              <b-button variant="flat-success" v-b-tooltip.hover title="Manifiestos y etiquetas" class="p-0" @click="openModal(scope.rowdata)">
                <feather-icon icon="FileTextIcon" />
              </b-button>
              <b-button v-if="dataUser.role === 'admin' && isSourceDelivery" variant="flat-success" v-b-tooltip.hover title="Ver logs" class="p-0" @click="openLogs(scope.rowdata)">
                <feather-icon icon="ArchiveIcon"></feather-icon>
              </b-button>
              <b-button v-if="isSourceDelivery" variant="flat-success" v-b-tooltip.hover title="Descargar Deliveries" class="p-0" @click="exportDeliveries(scope.rowdata)">
                <feather-icon icon="DownloadIcon"></feather-icon>
              </b-button>
            </div>
            <label v-if="showReopenOrCloseSummary(scope.rowdata)" class="switch" v-b-tooltip.hover :title="scope.rowdata.toolTipStatusSummary">
              <input type="checkbox" @click="reopenOrCloseSummary(scope.rowdata, $event)" v-model="scope.rowdata.active_summary">
              <span class="slider round"></span>
            </label>
          </template>
        </table-render>
      </div>
      <b-skeleton-table v-else
          :rows="pagination.limit || 10"
          :columns="schema.length || 10"
          :table-props="{ }"/>
        <modal-manifest-vue :dataManifest="dataManifest" @changeStatusGenerate="changeStatusGenerate" @closeModal="closeManifestModal" :sourceList="source" @updateDataSumamry="updateDataSumamry"></modal-manifest-vue>
        <modal-view-manifest-vue :dataManifest="dataViewManifest" @changeStatusConfirm="changeStatusManifest" @closeModal="closeManifestModal" :source="source" ></modal-view-manifest-vue>
        <modal-close-summary-as-admin :summaryId="summaryId" :deliveries="listDeliveries" @changeStatusManifest="changeStatusManifest"></modal-close-summary-as-admin>
    </b-card>
</template>
<script>
import modalManifestVue from './modalManifest.vue'
import ModalCloseSummaryAsAdmin from './ModalCloseSummaryAsAdmin.vue'
import modalViewManifestVue from './modalViewManifest.vue'
import { environment } from '@/environments/environment'
import BaseServices from '@/store/services/index'
import {endpoint} from './../endpoints.service.js'
export default {
  props: ['rowsData', 'pagination', 'show', 'sourceList'],
  components: {modalManifestVue, ModalCloseSummaryAsAdmin, modalViewManifestVue},
  data() {
    return {
      baseService: new BaseServices(this),
      permissions: {
        customSummariesV2: false
      },
      schema: [],
      actions: [],
      summaryId: null,
      listDeliveries: [],
      dataManifest: {},
      dataViewManifest: {}
    }
  },
  computed: {
    rows() {
      return this.rowsData && this.rowsData.length > 0 ? this.setSchemaDelivery(this.rowsData) : []
    },
    dataUser() {
      return this.$session.get('cas_user')
    },
    source() {
      return this.sourceList || this.$route.query.source || 'delivery'
    },
    isSourceDelivery() {
      return this.source === 'delivery'
    },
    endpointValues() {
      return endpoint[this.source]
    }
  },
  mounted() {
    this.setInitialData()
  },
  methods: {
    setSchemaDelivery(data) {
      return data.map(el => ({
        ...el,
        id: el.id,
        shipperTable: this.isSourceDelivery ? el.shipper?.name : el.organization?.name || el.shipper?.name,
        creatorUserTable: this.isSourceDelivery ? el.creator_user : el.user_email?.email || 'tracking@enviame.io',
        deliveryCountTable: el.deliveries?.length,
        statusNameTable: `Manifiesto ${el.status?.name}`,
        createdAtTable: el.created_at_format ? el.created_at_format : el.created_at,
        updatedAtTable: el.updated_at_format ? el.updated_at_format : el.updated_at,
        active_summary: el.status.id === 1,
        toolTipStatusSummary: this.setTooltipStatusSummary(el)
      }))
    },
    setInitialData() {
      this.schema = [
        {label: 'Manifiesto', key: 'id', useSlot: true},
        {label: 'Empresa', key: 'shipperTable'},
        {label: 'Courier', key: 'courierSlot', useSlot: true},
        {label: 'Marketplace', key: 'marketplaceSlot', useSlot: true, icon: 'AlertCircleIcon', text: 'Hover sobre los logos para ver detalle del modo de envío/tipo de logística.'},
        {label: 'Usuario', key: 'creatorUserTable'},
        {label: 'Envíos', key:'deliveryCountTable', class: ['text-center']},
        {label: 'Estado', key: 'statusNameTable'},
        {label: 'Fecha de creación', key: 'createdAtTable'},
        {label: 'Fecha de ultima modificación', key: 'updatedAtTable'},
        {label: 'Acciones', key: 'actionsSlot', useSlot: true, class: ['text-center thead--light']}
      ]
      this.setPermissions()
    },
    setPermissions() {
      this.permissions.customSummariesV2 = this.dataUser?.user_access?.custom_summaries_v2
      this.customTableByRole()
    },
    customTableByRole () {
      if (!this.permissions.customSummariesV2) this.schema = this.schema.filter(el => el.key !== 'marketplaceSlot')
    },
    formatDate(date) {
      return this.$options.filters.dbDateToFormat(date, 'dd-LL-y T')
    },
    closeManifestModal() {
      this.dataManifest = {}
      this.dataViewManifest = {}
    },
    changeStatusGenerate(data) {
      this.changeStatusManifest()
      if (data !== null) {
        this.openModal(data)
      }
    },
    changeStatusManifest() {
      this.$emit('updateManifest', true)
    },
    openModal(data) {
      if (data?.status?.code === 'OPEN') {
        this.dataManifest = {...data}
        this.$bvModal.show('modalManifest')
      } else {
        this.dataViewManifest = {...data}
        this.$bvModal.show('modalViewManifest')
      }
    },
    openModalReopen(data) {
      const options = {
        title: '',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'Reabrir',
        cancelTitle: 'Cancelar',
        cancelVariant: 'danger',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-0 border-top-0',
        centered: true
      }
      this.$bvModal.msgBoxConfirm('Esta acción reabrirá el manifiesto', options)
        .then(value => {
          if (value) {
            this.functionReopenManifest(data)
          }
        })
    },
    functionReopenManifest(data) {
      this.baseService.callService(this.endpointValues.postReopenSummaries, null, {idSummary: data.id}, { fullResponseError: true })
        .then(response => {
          this.changeStatusManifest()
        })
        .catch(err => {
          this.alertShow(err)
        })
    },
    openLogs(data) {
      // const url = (window.location !== window.parent.location) ? document.referrer  : `${document.location.origin}/`
      // window.open(`${url}summaries/${data.id}/logs`, '_blank')
      this.m_openWinBlank(`/summaries/${data.id}/logs`)
      // window.open(`${environment.platformUrl}/summaries/${data.id}/logs`, '_blank')
    },
    exportDeliveries(data) {
      this.baseService.callService(this.endpointValues.getExportDeliveries, null, {idSummary: data.id}, { fullResponseError: true })
        .then(response => {
          window.open(response.url, '_blank')
        })
        .catch(err => {
          this.alertShow(err)
        })
    },
    alertShow(err) {
      const text = 'Ha sucedido un error vuelve a intentarlo'
      let textMessage = ''
      if (typeof err === 'object' && typeof err[0] === 'string' && err[0] !== '') {
        textMessage = err[0]
      } else if (Array.isArray(err)) {
        textMessage += '<ul style="list-style-type: disc;">'
        err.forEach(element => {
          textMessage += `<li>${element.message}</li>`
        })
        textMessage += '</ul>'
      }
      this.$alert(textMessage ? textMessage : text)
    },
    updateDataSumamry (data) {
      this.summaryId = data.id
      this.listDeliveries = data.deliveries_summary
    },
    openSummaryDetails(summaryId) {
      const url = (window.location !== window.parent.location) ? `${document.referrer}summaries/${summaryId}` : `${document.location.origin}/summaries/${summaryId}`
      window.open(url, '_blank')
    },
    setTooltipStatusSummary(summary) {
      if (summary.status.id === 1) {
        return 'Deslice hacia la izquierda para cerrar manifiesto '
      } else if (summary.status.id === 2) {
        return 'Deslice hacia la derecha para abrir manifiesto'
      } else if (summary.status.id === 3) {
        return 'No es posible reabrir manifiesto'
      }
    },
    reopenOrCloseSummary(summary, event) {
      event.preventDefault()
      if (summary.status.id === 3) {
        this.$warning('No es posible reabrir el manifiesto\n porque ya ha sido confirmado.', null, 'Acción no disponible', 'Entendido', 'btn btn-outline-warning')
        return
      }
      if (summary.active_summary) {
        this.$confirm(`¿Está seguro que desea cerrar el manifiesto ${summary.id}?\n Una vez cerrado podrá imprimirlo.`, () => this.functionCloseSummary(summary), 'Cerrar Manifiesto')
      } else {
        this.$confirm(`Está seguro que desea abrir el manifiesto ${summary.id}\n Recuerde cerrarlo posteriormente para reimprimir.`, () => this.functionReopenSummary(summary), 'Abrir Manifiesto')
      }
    },
    functionCloseSummary(summary) {
      summary.active_summary = false
    },
    functionReopenSummary(summary) {
      summary.active_summary = true
      this.baseService.callService(this.endpointValues.postReopenSummaries, null, {idSummary: summary.id}, { fullResponseError: true })
        .then(response => {
          this.changeStatusManifest()
        })
        .catch(err => {
          this.alertShow(err)
        })
    },
    showReopenOrCloseSummary(summary) {
      // Se muestra la acción ReopenOrCloseSummary si el manifiesto está cerrado o confirmado
      return (summary.status.id === 2 || summary.status.id === 3) && this.isSourceDelivery
    }
  }
}
</script>
<style lang="scss">
  .table-manifest--buttons {
    display: grid;
    gap: 10px;
    grid-auto-flow: column;
    justify-content: center;
  }
  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 3.5px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked+.slider {
    background-color: #1E8E3E;
  }

  input:focus+.slider {
    box-shadow: 0 0 1px #1E8E3E;
  }

  input:checked+.slider:before {
    -webkit-transform: translateX(19px);
    -ms-transform: translateX(19px);
    transform: translateX(19px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 35px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
</style>